import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";

export default function ScheduledEmailStats({
  open,
  setOpen,
  singleEmail,
  event,
}) {
  const [emailStats, setEmailStats] = useState([]);
  const getScheduledEmailStats = async (email) => {
    let formattedDate;
    formattedDate = email?.campaignTime.split("T")[0];

    if (singleEmail?.isRegistrationEmail && event?.createdAt) {
      formattedDate = event?.createdAt.split("T")[0];
    }

    const selectedMetrics = [
      "requests",
      "delivered",
      "opens",
      "clicks",
      "bounces",
      "unique_opens",
    ];
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/event/getScheduledEmailStats`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            category: email?._id,
            campaignDate: formattedDate,
          }),
        }
      );
      const stats = await response.json();
      const metricArray = selectedMetrics.map((key) => ({
        name:
          key === "requests"
            ? "Sent"
            : key === "opens"
            ? "Opened"
            : key === "unique_opens"
            ? "Unique Opens"
            : capitalizeFirstLetter(key),
        count: stats.data?.[key],
        color:
          key === "opens"
            ? "primary"
            : key === "requests"
            ? "blue-500"
            : key === "bounces"
            ? "danger"
            : key === "delivered"
            ? "green-500"
            : key === "clicks"
            ? "yellow-500"
            : key === "unique_opens"
            ? "blue-900"
            : "",
      }));
      setEmailStats(metricArray);
    } catch (error) {
      console.log(error);
    }
  };

  const capitalizeFirstLetter = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  };

  useEffect(() => {
    if (open && singleEmail?.emailSubject) {
      setEmailStats([]);
      getScheduledEmailStats(singleEmail);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singleEmail, open]);

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="z-40 fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="z-40 fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto relative w-screen max-w-md">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-in-out duration-500"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in-out duration-500"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div className="absolute top-0 left-[45px] md:left-0 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4">
                        <button
                          type="button"
                          className="rounded-md outline-none hidden md:block text-gray-300"
                          onClick={() => setOpen(false)}
                        >
                          <span className="sr-only">Close panel</span>X
                        </button>
                        <button
                          className="md:hidden flex items-center"
                          onClick={() => setOpen(false)}
                        >
                          <i className="fa fa-angle-left text-[24px]"></i>
                          <span className="text-[17px] pt-0.5">Back</span>
                        </button>
                      </div>
                    </Transition.Child>
                    <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                      <div className="px-4 sm:px-6 fixed z-20 bg-white w-[100%] top-0">
                        <Dialog.Title className="text-[22px] pb-[25px] font-[600] text-gray-900 pt-5">
                          Email Stats
                        </Dialog.Title>
                      </div>
                      <div className="relative mt-[60px] flex-1 px-4 sm:px-6 mb-[50px] ">
                        {emailStats.length > 0 ? (
                          <div className=" h-[500px]">
                            {emailStats?.map((stats) => {
                              return (
                                <div
                                  className="w-[100%] h-[55px] flex mb-3 rounded-[10px]"
                                  style={{
                                    boxShadow:
                                      "0px 0px 14px rgba(165, 94, 234, 0.2)",
                                  }}
                                >
                                  <div className="w-[50%] flex items-center  pl-2">
                                    <p className="text-[20px] font-[500] text-gray-500">
                                      {stats?.name}
                                    </p>
                                  </div>
                                  <div
                                    className={`w-[50%] flex items-center pr-3 text-${stats?.color} justify-end`}
                                  >
                                    <span className={`font-[600] text-[22px]`}>
                                      {stats?.count}
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div className=" w-full h-full flex justify-center items-center flex-col">
                            <svg
                              className="inline mr-2 w-11 h-11 text-gray-200 animate-spin dark:text-gray-600 fill-primary"
                              viewBox="0 0 100 101"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"
                              />
                              <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"
                              />
                            </svg>
                          </div>
                        )}
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
